export default function Backdrop(theme) {
  return {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          '&:not(.MuiBackdrop-invisible)': {
            backgroundColor: theme.palette.background.backdrop,
            backdropFilter: 'blur(4px)',
          },
        },
      },
    },
  }
}
